import { render, staticRenderFns } from "./courseTemplate.vue?vue&type=template&id=50ec7819&scoped=true&"
import script from "./courseTemplate.vue?vue&type=script&lang=js&"
export * from "./courseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./courseTemplate.vue?vue&type=style&index=0&id=50ec7819&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec7819",
  null
  
)

export default component.exports